import { PowerOffice, Integration } from "@/types/general";
import { transformResponse } from "../../api/internalApiSlice";
import { integrationsApi } from "./integrationsApi";

export const powerofficeApi = integrationsApi.injectEndpoints({
    endpoints: (builder) => ({
        getPOGOSalesAccounts: builder.query<PowerOffice.SalesAccounts.Root[], void>({
            query: () => ({
                url: "poweroffice/sales-accounts",
            }),
            transformResponse,
        }),

        getPOGOProjects: builder.query<PowerOffice.Projects.Root[], void>({
            query: () => ({
                url: "poweroffice/projects",
            }),
            transformResponse,
        }),

        importPOGOData: builder.mutation<void, PowerOffice.DTO.ImportProductsRequest>({
            query: (data) => ({
                url: "data-transfer/integrations/poweroffice/import",
                method: "POST",
                data: {
                    default_product_location: {
                        store_id: data.store_id,
                        section_id: data.section_id,
                    },
                    ...(data.reimport_confirmed && { reimport_confirmed: true }),
                },
            }),
        }),

        importPowerOfficeCustomers: builder.mutation<PowerOffice.DTO.ImportResult, void>({
            query: () => ({
                url: "data-transfer/integrations/poweroffice/import/customers",
                method: "POST",
            }),
            invalidatesTags: [
                { type: "Customer", id: "LIST" },
                { type: "Customer", id: "PARTIAL-LIST" },
            ],
            transformResponse,
        }),

        importPowerOfficeSuppliers: builder.mutation<PowerOffice.DTO.ImportResult, void>({
            query: () => ({
                url: "data-transfer/integrations/poweroffice/import/suppliers",
                method: "POST",
            }),
            invalidatesTags: [
                { type: "Supplier", id: "LIST" },
                { type: "Supplier", id: "PARTIAL-LIST" },
            ],
            transformResponse,
        }),

        updatePOGOConfiguration: builder.mutation<
            Integration.ActiveState.PowerOfficeGO,
            PowerOffice.DTO.UpdateConfiguration
        >({
            query: (data) => ({
                url: "integrations/configuration",
                method: "PUT",
                data: {
                    integration: "poweroffice",
                    configuration: data,
                },
            }),
            transformResponse,
        }),
    }),
});

export const {
    useGetPOGOSalesAccountsQuery,
    useGetPOGOProjectsQuery,
    useImportPOGODataMutation,
    useImportPowerOfficeCustomersMutation,
    useImportPowerOfficeSuppliersMutation,
    useUpdatePOGOConfigurationMutation,
} = powerofficeApi;
